﻿import { OpaccBasketInfo } from './vendor/script/classes/opacc.class.basket-info.js';
import { CustomBasketAction  } from './custom.class.basket-action.js';
import { OpaccBasketPayment  } from './vendor/script/classes/opacc.class.basket-payment.js';
import { OpaccBasketShipping  } from './vendor/script/classes/opacc.class.basket-shipping.js';

export const opaccBasketInfoPlugin = new OpaccBasketInfo();
export const opaccBasketActionPlugin = new CustomBasketAction();
export const opaccBasketPaymentPlugin = new OpaccBasketPayment();
export const opaccBasketShippingPlugin = new OpaccBasketShipping();




